var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeExcelB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2124,
    cy: 16.7905,
    r: 16.7905,
    fill: "#E4EEF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_3195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4894 17.7025H20.1447V16.5302H22.4894V17.7025ZM22.4894 18.3724H20.1447V19.5447H22.4894V18.3724ZM22.4894 12.8457H20.1447V14.018H22.4894V12.8457ZM22.4894 14.688H20.1447V15.8603H22.4894V14.688ZM22.4894 20.2146H20.1447V21.387H22.4894V20.2146ZM24.1089 22.5258C24.0419 22.8742 23.6232 22.8825 23.3435 22.8943H18.1351V24.4015H17.095L9.42969 23.0617V11.3401L17.1403 9.99866H18.1351V11.3334H23.1643C23.4474 11.3452 23.7589 11.3251 24.005 11.4942C24.1776 11.7421 24.1608 12.0569 24.1725 12.3416L24.1658 21.0604C24.1575 21.5477 24.211 22.0452 24.1089 22.5258ZM15.571 19.8981C15.1088 18.9603 14.6382 18.0291 14.1776 17.0912C14.6331 16.1785 15.082 15.2624 15.5291 14.3463C15.149 14.3647 14.7688 14.3882 14.3903 14.415C14.1073 15.1033 13.7773 15.7732 13.5563 16.485C13.3503 15.8134 13.0773 15.1669 12.8278 14.5121C12.4593 14.5322 12.0909 14.554 11.7224 14.5757C12.111 15.4332 12.5247 16.2789 12.9015 17.1415C12.4576 17.9788 12.0423 18.828 11.6119 19.6703C11.9786 19.6854 12.3454 19.7005 12.7122 19.7055C12.9735 19.039 13.2984 18.3975 13.5261 17.7176C13.7305 18.4478 14.0771 19.1227 14.3618 19.8211C14.7654 19.8496 15.1674 19.8747 15.571 19.8981ZM23.3738 12.1288H18.1351V12.8457H19.4749V14.018H18.1351V14.688H19.4749V15.8603H18.1351V16.5302H19.4749V17.7025H18.1351V18.3724H19.4749V19.5447H18.1351V20.2146H19.4749V21.387H18.1351V22.1615H23.3738V12.1288Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_3195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7429,
    height: 14.7429,
    fill: "white",
    transform: "translate(9.42969 9.82861)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeExcelB);
export default __webpack_public_path__ + "static/media/IconeExcelB.98cb9f865bc2e9a8f6a45c9465420407.svg";
export { ForwardRef as ReactComponent };